import { render, staticRenderFns } from "./pageConfig.vue?vue&type=template&id=5f20b647&scoped=true"
import script from "./pageConfig.vue?vue&type=script&lang=js"
export * from "./pageConfig.vue?vue&type=script&lang=js"
import style0 from "./pageConfig.vue?vue&type=style&index=0&id=5f20b647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20b647",
  null
  
)

export default component.exports